/**
 * ActiveProIndicator - Visual indicator showing which Pro account is currently selected
 * Displays for Upercut users only
 */

import { useAuth } from '@contexts/AuthContext';
import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import AutoCompletePro from './AutoComplete/AutoCompletePro';
import { useProId } from '@contexts/ProIdContext';
import { useNavigate } from 'react-router-dom';
import { useApolloClient } from '../apollo';

interface ActiveProIndicatorProps {
  variant?: 'chip' | 'banner' | 'inline';
  showEmail?: boolean;
  size?: 'small' | 'medium';
}

/**
 * ActiveProIndicator component
 * 
 * @param {boolean} showEmail - Show Pro email address
 * @param {string} size - Size of the indicator
 * 
 */
const ActiveProIndicator: React.FC<ActiveProIndicatorProps> = () => {
  const { isUpercut, isAuthenticated } = useAuth();
  const { setProId } = useProId();
  const navigate = useNavigate();
  const { updateProIdToClient } = useApolloClient();

  const handleQuit = () => {
    setProId(null);
    updateProIdToClient(null);
    navigate('/');
  }

  // Don't render for non-Upercut users or when no proId is selected
  if (!isAuthenticated || !isUpercut) {
    return null;
  }

  // Inline variant
  return (
    <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between" sx={{ width: '100%' }}>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Typography
          variant="body2"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            color: 'text.secondary',
            // don't wrap 
            whiteSpace: 'nowrap',
          }}
        >
          Agissant en tant que:
        </Typography>
        <AutoCompletePro required size="small" onChange={(proId) => {
          if (!proId) return;
          setProId(proId);
          updateProIdToClient(proId);
        }} />
      </Stack>
      <Button onClick={handleQuit} color="error" variant="outlined">
        Quitter le mode aperçu
      </Button>
    </Stack>
  );
};

export default ActiveProIndicator;
